import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import facultyData from "../UG/facultyData/cseFacultyData";
import cseAimlFacultyData from "../UG/facultyData/cseAimlFacultyData";

const combinedFacultyData = {
  ...facultyData,
  members: [
    ...(facultyData.members || []),
    cseAimlFacultyData.hod,
    ...(cseAimlFacultyData.members || []),
  ].filter(Boolean),
};

export const programme = {
  id: "cse-research",
  name: "Computer Science & Engineering Research Centre",
  short: "CSE Research Centre",
  programmeType: "research",
  programmeLabel: "Research Centre",
  duration: "Ph.D. / M.Sc. (Engg.) by Research",
  established: "2023-24",
  facultyData: combinedFacultyData,
  hideFacultySection: true,
  hideSharedClubs: true,

  description:
    "The Department of Computer Science & Engineering at KLS VDIT, Haliyal, was recognized as a Research Centre by Visvesvaraya Technological University during the academic year 2023-24. This recognition enables the department to offer Ph.D. and M.Sc. (Engineering) by Research programmes under VTU.",

  image:
    "/Infrastructure/CSE/3.jpg",

  labs: [
    "Research Computing Facility",
    "Machine Learning & Data Analytics Lab",
    "IoT and Embedded Systems Research Lab",
    "Network Simulation Facility",
    "Computer Vision & NLP Research Facility",
  ],

  dashboard: [
    ["Recognized Since", "2023-24"],
    ["Research Areas", "06"],
    ["Research Supervisors", "02"],
    ["Research Scholars", "06"],
  ],

  quickFacts: [
    ["Established", "2023-24"],
    ["Programme", "Ph.D. / M.Sc. (Engg.) by Research"],
    ["Research Supervisors", "02"],
    ["Research Scholars", "06"],
    ["Research Areas", "WSN, Machine Learning, IoT, NLP, Image Processing"],
    ["Affiliation", "VTU, Belagavi"],
  ],

  academicOverview: [
    {
      title: "Research Centre Overview",
      text:
        "The CSE Research Centre supports research in computing, intelligent systems, networks, IoT, data analytics, computer vision, and natural language processing. The centre provides facilities for doctoral and M.Sc. (Engineering) research under VTU.",
    },
    {
      title: "Research Facilities",
      text:
        "The department is equipped with HP desktop computers, network simulation tools, Python-based research environments, machine learning libraries, deep learning frameworks, computer vision tools, NLP toolkits, Arduino kits, ESP32 boards, Raspberry Pi systems, and sensor modules.",
    },
    {
      title: "Research Culture",
      text:
        "The centre promotes research-oriented learning, software experimentation, prototype development, IoT applications, machine learning models, and interdisciplinary innovation through faculty supervision and scholar engagement.",
    },
  ],

  curriculumSupport: [
    "Ph.D. and M.Sc. (Engineering) by Research guidance",
    "Machine learning and deep learning experimentation",
    "IoT and embedded systems prototype development",
    "Network simulation using NS-3",
    "Computer vision and image processing research",
    "Natural language processing and text analytics",
    "Data analytics using Python, NumPy, Pandas and Scikit-learn",
    "Research publication and technical documentation support",
  ],

  researchAreas: [
    "Wireless Sensor Networks",
    "Machine Learning",
    "Internet of Things",
    "Natural Language Processing",
    "Image Processing",
    "Data Analytics",
  ],

  infrastructure: [
    ["HP Desktop Computers", "5"],
    ["Processor", "12th Gen Intel Core i5-12500, 3.00 GHz"],
    ["RAM", "16 GB"],
    ["Operating System", "64-bit OS, x64-based Processor"],
    ["NS-3", "Open Source"],
    ["Python", "Python 3.7.14"],
    ["Jupyter Notebook", "Open Source"],
    ["Scikit-learn", "Open Source"],
    ["TensorFlow", "Open Source"],
    ["PyTorch", "Open Source"],
    ["OpenCV", "Open Source"],
    ["NLTK", "Open Source"],
    ["SpaCy", "Open Source"],
    ["Arduino Development Kit", "5"],
    ["ESP32 Development Board", "5"],
    ["Raspberry Pi", "2"],
    ["Sensor Modules", "10"],
  ],

  achievements: [
    "Recognized as a VTU Research Centre in 2023-24.",
    "Offers Ph.D. and M.Sc. (Engineering) by Research programmes.",
    "Research facilities support machine learning, IoT, WSN, NLP, and image processing.",
    "Faculty supervisors guide scholars in advanced computing research areas.",
  ],

  supervisors: [
    ["Dr. Venkatesh Shankar", "Professor, Head of Department", "f-venkatesh-shankar"],
    ["Dr. Poornima Raikar", "Assistant Professor, Head of Department", "f-poornima-raikar"],
  ],

  researchScholars: [
    ["Mr. Bhagat Inamdar", "Assistant Professor - Wireless Sensor Network", "f-bhagat-inamdar"],
    ["Mr. Ravindra Patil", "Assistant Professor - Machine Learning", "f-ravindra-patil"],
    ["Ms. Farajanabegaum Nadaf", "Assistant Professor - Internet of Things", "f-farajanabegaum-nadaf"],
    ["Mr. Girish Shivanagudi", "Assistant Professor - Natural Language Processing", "f-girish-n-shivanagudi"],
    ["Mrs. Sunita Kallu", "Assistant Professor - Wireless Sensor Networks", "f-sunita-kallu"],
    ["Mrs. Preeti Mane", "Assistant Professor - Image Processing", null, "/FacultyCImages/preetimane.jpeg"],
  ],
};

const CSEResearchCentre = () => <ProgrammeDetail programme={programme} />;

export default CSEResearchCentre;
